(() => {
  const GIFT_PROPERTY = '_batman_day_gift';
  let syncing = false;
  let queued = false;

  const request = async (url, options = {}) => {
    const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', ...options});
    if (!response.ok) throw new Error('No se pudo actualizar la promoción Batman Day.');
    return response;
  };

  const getRenderedState = async () => {
    const response = await request(`${window.themeVariables.routes.cartUrl}?section_id=mini-cart`);
    const holder = document.createElement('div');
    holder.innerHTML = await response.text();
    return holder.querySelector('batman-cart-promotion');
  };

  const getCart = async () => {
    const response = await request(`${window.themeVariables.routes.cartUrl}.js`);
    return response.json();
  };

  const changeLine = async (key, quantity) => {
    await request(`${window.themeVariables.routes.cartChangeUrl}.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity})
    });
  };

  const addGift = async (variantId) => {
    await request(`${window.themeVariables.routes.cartAddUrl}.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        items: [{id: variantId, quantity: 1, properties: {[GIFT_PROPERTY]: 'true'}}]
      })
    });
  };

  const refreshThemeCart = async () => {
    if (window.themeVariables.settings.pageType === 'cart') {
      window.location.reload();
      return;
    }
    const response = await request(`${window.themeVariables.routes.cartUrl}.js?sections=mini-cart`);
    const cart = await response.json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {bubbles: true, detail: {cart}}));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true, detail: {cart}}));
  };

  const normalizeGift = async (cart, variantId, shouldExist) => {
    if (!variantId) return false;
    const lines = cart.items.filter(item => Number(item.variant_id) === variantId);
    const validLine = lines.find(item =>
      String(item.properties?.[GIFT_PROPERTY]) === 'true' && item.quantity === 1
    );

    if (!shouldExist) {
      const promoLines = lines.filter(item => String(item.properties?.[GIFT_PROPERTY]) === 'true');
      for (const line of promoLines) await changeLine(line.key, 0);
      return promoLines.length > 0;
    }

    if (validLine && lines.length === 1) return false;
    for (const line of lines) await changeLine(line.key, 0);
    await addGift(variantId);
    return true;
  };

  const synchronize = async () => {
    if (syncing) {
      queued = true;
      return;
    }
    syncing = true;
    document.documentElement.classList.add('batman-promo-syncing');

    try {
      const state = await getRenderedState();
      if (!state) return;

      const dcTotal = Number(state.dataset.dcEligibleTotal || 0);
      const batmanTotal = Number(state.dataset.batmanEligibleTotal || 0);
      const firstGoal = Number(state.dataset.firstGoal || 9990000);
      const secondGoal = Number(state.dataset.secondGoal || 15990000);
      const toteMaskId = Number(state.dataset.toteMaskVariant || 0);
      const comicId = Number(state.dataset.comicVariant || 0);
      const cart = await getCart();

      let changed = await normalizeGift(cart, toteMaskId, dcTotal >= firstGoal);
      const currentCart = changed ? await getCart() : cart;
      changed = await normalizeGift(currentCart, comicId, batmanTotal >= secondGoal) || changed;

      if (changed) await refreshThemeCart();
    } catch (error) {
      console.warn('[Batman Day]', error.message);
    } finally {
      syncing = false;
      document.documentElement.classList.remove('batman-promo-syncing');
      if (queued) {
        queued = false;
        window.setTimeout(synchronize, 100);
      }
    }
  };

  document.addEventListener('DOMContentLoaded', synchronize, {once: true});
  document.documentElement.addEventListener('cart:refresh', () => window.setTimeout(synchronize, 0));
  document.documentElement.addEventListener('cart:updated', () => window.setTimeout(synchronize, 0));
})();
